import React from 'react';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import Ourservices from '../Components/Services/Ourervices';


const Services = () => {
  return (
    <div>
        <Header />
        <Ourservices />
        <Footer />
    </div>
  )
}

export default Services
